/**
 * https://github.com/willhoag/scroll-to-element/blob/master/index.js
 *
 * @param elem
 * @param additionalOffset
 * @param alignment
 * @returns {number}
 */
export default function calculateScrollOffset(elem, additionalOffset, alignment) {
    const {body, documentElement: html} = document;

    const elemRect = elem.getBoundingClientRect();
    const {clientHeight} = html;
    const documentHeight = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight,
    );

    additionalOffset = additionalOffset || 0;

    let scrollPosition;
    if (alignment === 'bottom') {
        scrollPosition = elemRect.bottom - clientHeight;
    } else if (alignment === 'middle') {
        scrollPosition = elemRect.bottom - clientHeight / 2 - elemRect.height / 2;
    } else { // top and default
        scrollPosition = elemRect.top;
    }

    const maxScrollPosition = documentHeight - clientHeight;
    return Math.min(
        scrollPosition + additionalOffset + window.pageYOffset,
        maxScrollPosition,
    );
}
